import $ from "jquery";

// $(window).scroll(function(){
//   if($(window).scrollTop() >  400 && $(window).scrollTop() <  1000) {
//     $('.scrolling').addClass('end');
//     $('.scrolling').removeClass('fixed');
//   }else{
//     $('.scrolling').addClass('fixed');
//     $('.scrolling').removeClass('end');
//   }
// });

if ($('.scrolling').length){
    var scrollingDistance = $('.scrolling').offset().top,
        calculatorCta = $('.scrolling_endline').offset().top,
        $window = $(window);

    $window.scroll(function() {
        if ( $window.scrollTop() >= scrollingDistance ) {
            $('.scrolling').addClass('fixed');
            $('.scrolling').removeClass('end');
        } else {
            $('.scrolling').removeClass('fixed');
        }
        if ( $window.scrollTop() >= calculatorCta ) {
            $('.scrolling').addClass('end');
            $('.scrolling').removeClass('fixed');
        }
    });
}